import { render } from "./indexGuestTitlePage.vue?vue&type=template&id=8725614e"
import script from "./indexGuestTitlePage.vue?vue&type=script&lang=js"
export * from "./indexGuestTitlePage.vue?vue&type=script&lang=js"

import exportComponent from "/datamining/www/front-vue.m-direct.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__